import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e2af03d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-details__field" }
const _hoisted_2 = { class: "member-details__label" }

import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import CustomModal from '@/components/CustomModal.vue';
import { Member } from '@/Member/member.entity';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberDetailsModal',
  props: {
    member: {
        type: Object as PropType<Member>,
        required: true,
    },
},
  emits: ['close'],
  setup(__props) {

const props = __props;





const { member } = toRefs(props);

const { t } = useI18n();

const fullName = computed(() => `${member.value.firstName ?? ''} ${member.value.lastName ?? ''}`.trim());

const roleLabel = computed(() => (member.value.role ? t('listMembers.roles.' + member.value.role) : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(CustomModal, {
      "min-width": "600px",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, {
      "modal-header": _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(fullName.value), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('listMembers.role')), 1),
          _createElementVNode("span", null, _toDisplayString(roleLabel.value), 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})